var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "life-header",
      class: { "clear-header": _vm.showClearHeader }
    },
    [
      _c("div", { staticClass: "header-wrapper" }, [
        _c("div", { staticClass: "logo-box" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "menu-box" },
          [
            _vm._l(_vm.menuList, function(item) {
              return _c(
                "span",
                {
                  key: item.path,
                  class: _vm.path.startsWith(item.path) ? "activeItem" : "",
                  on: {
                    click: function($event) {
                      return _vm.handleClickMenu(item.path)
                    }
                  }
                },
                [_vm._v(_vm._s(item.name))]
              )
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "menu-account" },
              [
                _vm.loginInfo.uid
                  ? _c(
                      "el-dropdown",
                      {
                        attrs: { trigger: "click" },
                        on: { command: _vm.handleCommand }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "avatar-wrapper" },
                          [
                            _vm.loginInfo.avatar
                              ? _c("img", {
                                  staticClass: "avatar",
                                  attrs: {
                                    src: _vm.loginInfo.avatar,
                                    alt: "avatar"
                                  }
                                })
                              : _c("DefaultAvatar", {
                                  staticClass: "avatar",
                                  attrs: { alt: "avatar" }
                                }),
                            _vm._v(" "),
                            _vm.loginInfo.pro > 0
                              ? _c("CrownIcon", { staticClass: "crown" })
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          [
                            _c(
                              "el-dropdown-item",
                              { attrs: { command: "logOut" } },
                              [_c("span", [_vm._v("退出登录")])]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _c(
                      "button",
                      {
                        staticClass: "btn-log-in",
                        on: {
                          click: function($event) {
                            return _vm.handleLogIn()
                          }
                        }
                      },
                      [_vm._v("登录")]
                    )
              ],
              1
            )
          ],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }